export default [
  {
    key: "platformCode",
    rules: {
      isRequired: true,
    }
  },
]
